var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGmail(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#f55376",
    d: "M12,22.854V10.445l12,9l12-9v12.409l-12,9L12,22.854z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#6c19ff",
    d: "M12,22.854l-9-6.75v21.032C3,38.721,4.284,40,5.864,40H12V22.854z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#eb0000",
    d: "M12,10.445L9.873,8.85C7.038,6.726,3,8.745,3,12.286v3.818l9,6.75V10.445z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#3ddab4",
    d: "M36,22.854V40h6.136C43.721,40,45,38.716,45,37.136V16.105L36,22.854z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#f5bc00",
    d: "M38.127,8.85L36,10.445v12.409l9-6.75v-3.818C45,8.745,40.958,6.726,38.127,8.85z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmail);
export default __webpack_public_path__ + "static/media/gmail.f7f4f60d3b0f8df2280205cb98b2b5ae.svg";
export { ForwardRef as ReactComponent };